import {ChevronDown} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const ArrowDropDownIcon = createLucideIcon(ChevronDown, 'ArrowDropDownIcon');
